<template>
  <div>
    <header class="header">
      <div style="position: absolute;left: 16px;top: 17px;">
        <router-link :to="{name:'manage apps'}"><span class="path">我的应用 / </span></router-link>
        <span class="active">{{ appInfo.appName }}</span>
      </div>
    </header>

    <main class="main">
      <el-tabs value="second">
        <el-tab-pane label="已发布" name="first">
          <article
              class="table"
              v-loading="loadingPassData">
            <el-table
                :empty-text="'没有数据'"
                :data="passReleaseList"
                :fit="true"
                style="width: 100%">
              <el-table-column
                  align="center"
                  type="index"
                  label="序号"
                  :index="indexMethod" width="90px">
              </el-table-column>
              <el-table-column
                  align="center"
                  prop="version"
                  label="版本">
              </el-table-column>

              <el-table-column
                  align="center"
                  label="规则">
                  <template slot-scope="scope">
                  {{ getShortRule(scope.row.ruleList) }}
                </template>
              </el-table-column>

              <el-table-column
                  align="center"
                  label="创建人">
                <template slot-scope="scope">
                  {{ getCreatorName(scope.row.creator) }}
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  prop="releaseTime"
                  label="创建时间">
              </el-table-column>
              <el-table-column
                  v-if="this.appInfo.enableCheckRelease"
                  align="center"
                  label="操作">
                <template slot-scope="scope">
                  <el-link type="primary" style="margin-right: 10px" @click="openViewDialog(scope.row)">查看</el-link>
                  <el-link type="danger" @click="handleDeleteRelease(scope.row.id)">删除</el-link>
                </template>
              </el-table-column>
              <el-dialog title="查看审核" :visible.sync="viewDialogVisible" :append-to-body="true">
                <article v-if="viewDialogVisible">
                  <el-row>
                    <el-col :span="4">应用名称</el-col>
                    <el-col :span="8">{{ appInfo.appName }}</el-col>
                    <el-col :span="4">版本</el-col>
                    <el-col :span="8">{{ viewReleaseData.version }}</el-col>
                  </el-row>
                  <el-row style="margin-top: 15px">
                    <el-col :span="4">创建人</el-col>
                    <el-col :span="8">{{ viewReleaseData.creator.username }}</el-col>
                    <el-col :span="4">时间</el-col>
                    <el-col :span="8">{{ viewReleaseData.releaseTime }}</el-col>
                  </el-row>
                  <el-row style="margin-top: 15px">
                    <el-col :span="4">更新日志</el-col>
                    <el-col :span="20">{{ viewReleaseData.releaseLogs[0] }}</el-col>
                  </el-row>
                  <el-row style="margin-top: 15px">
                    <el-col :span="4">文件</el-col>
                    <el-col :span="20">{{ viewReleaseData.newDlUrl }}</el-col>
                  </el-row>
                  <section v-for="(item,index) in viewReleaseData.ruleList" :key="index"
                           style="border-top: rgb(127,127,127) solid 1px;margin-top: 15px">
                    <div
                        v-if="item.ruleType === 'INTEGER' || item.ruleType === 'STRING' || item.ruleType === 'VERSION' ">
                      <el-row :span="4" style="margin-top: 15px">
                        <el-col :span="4">类型</el-col>
                        <el-col :span="8">{{ item.ruleType }}</el-col>
                        <el-col :span="4">原始参数名</el-col>
                        <el-col :span="8">{{ item.dataName }}</el-col>
                      </el-row>
                      <div v-for="(ruleItem,ruleIndex) in item.ruleFunctions" :key="ruleIndex">
                        <el-row style="margin-top: 15px">
                          <el-col :span="4">比较对象</el-col>
                          <el-col :span="8">{{ ruleItem.compareTo }}</el-col>
                          <el-col :span="4">比较方法</el-col>
                          <el-col :span="8">{{ ruleItem.operator }}</el-col>
                        </el-row>
                        <el-row style="margin-top: 15px">
                          <el-col :span="4">比较逻辑</el-col>
                          <el-col :span="20">{{ ruleItem.logicalOperator }}</el-col>
                        </el-row>
                      </div>
                    </div>
                    <div v-if="item.ruleType === 'PERCENTAGE'">
                      未写完
                    </div>
                    <div v-if="item.ruleType === 'CUSTOM'">
                      未写完
                    </div>
                  </section>
                </article>
                <div slot="footer">
                  <el-button type="primary" @click="viewDialogVisible = false">关闭</el-button>
                </div>
              </el-dialog>
            </el-table>
          </article>
        </el-tab-pane>
        <el-tab-pane label="待审核" name="second">
          <header style="margin-top: 10px">
            <section style="display: inline-block;color: rgba(51, 51, 51, 100);font-size: 18px;font-weight: bold">发布信息
            </section>
            <section style="display: inline-block;float: right">
              <router-link :to="{name:'create app release',query:{appId: appInfo.appId,appName: appInfo.appName}}">
                <el-button type="primary">添加发布</el-button>
              </router-link>
            </section>
          </header>
          <!--      表格主体-->
          <article
              class="table"
              v-loading="loadingCheckingData">
            <el-table
                :empty-text="'没有数据'"
                :data="checkingReleaseList"
                :fit="true"
                style="width: 100%">
              <el-table-column
                  align="center"
                  type="index"
                  label="序号"
                  :index="indexMethod" width="90px">
              </el-table-column>
              <el-table-column
                  align="center"
                  prop="version"
                  label="版本">
              </el-table-column>
              <el-table-column
                  align="center"
                  label="创建人">
                <template slot-scope="scope">
                  {{ getCreatorName(scope.row.creator) }}
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  prop="releaseTime"
                  label="创建时间">
              </el-table-column>
              <el-table-column
                  v-if="this.appInfo.enableCheckRelease"
                  align="center"
                  label="操作">
                <template slot-scope="scope">
                  <el-link style="margin-right: 10px" type="primary" @click="openCheckDialog(scope.row)">审核</el-link>
                  <el-link type="danger" @click="handleDeleteRelease(scope.row.id)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog title="发布审核" :visible.sync="checkDialogVisible" >
              <article v-if="checkDialogVisible">
                <el-row>
                  <el-col :span="4">应用名称</el-col>
                  <el-col :span="8">{{ appInfo.appName }}</el-col>
                  <el-col :span="4">版本</el-col>
                  <el-col :span="8">{{ checkReleaseData.version }}</el-col>
                </el-row>
                <el-row style="margin-top: 15px">
                  <el-col :span="4">创建人</el-col>
                  <el-col :span="8">{{ checkReleaseData.creator.username }}</el-col>
                  <el-col :span="4">时间</el-col>
                  <el-col :span="8">{{ checkReleaseData.releaseTime }}</el-col>
                </el-row>
                <el-row style="margin-top: 15px">
                  <el-col :span="4">更新日志</el-col>
                  <el-col :span="20">{{ checkReleaseData.releaseLogs[0] }}</el-col>
                </el-row>
                <el-row style="margin-top: 15px">
                  <el-col :span="4">文件</el-col>
                  <el-col :span="20">{{ checkReleaseData.newDlUrl }}</el-col>
                </el-row>
                <section v-for="(item,index) in checkReleaseData.ruleList" :key="index"
                         style="border-top: rgb(127,127,127) solid 1px;margin-top: 15px">
                  <div v-if="item.ruleType === 'INTEGER' || item.ruleType === 'STRING' || item.ruleType === 'VERSION'">
                    <el-row :span="4" style="margin-top: 15px">
                      <el-col :span="4">类型</el-col>
                      <el-col :span="8">{{ item.ruleType }}</el-col>
                      <el-col :span="4">原始参数名</el-col>
                      <el-col :span="8">{{ item.dataName }}</el-col>
                    </el-row>
                    <div v-for="(ruleItem,ruleIndex) in item.ruleFunctions" :key="ruleIndex">
                      <el-row style="margin-top: 15px">
                        <el-col :span="4">比较对象</el-col>
                        <el-col :span="8">{{ ruleItem.compareTo }}</el-col>
                        <el-col :span="4">比较方法</el-col>
                        <el-col :span="8">{{ ruleItem.operator }}</el-col>
                      </el-row>
                      <el-row style="margin-top: 15px">
                        <el-col :span="4">比较逻辑</el-col>
                        <el-col :span="20">{{ ruleItem.logicalOperator }}</el-col>
                      </el-row>
                    </div>
                  </div>
                  <div v-if="item.ruleType === 'PERCENTAGE'">
                    未写完
                  </div>
                  <div v-if="item.ruleType === 'CUSTOM'">
                    未写完
                  </div>
                </section>
              </article>
              <div slot="footer">
                <el-button @click="checkDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleAuditRelease(checkReleaseData.id)">通过</el-button>
              </div>
            </el-dialog>
          </article>
        </el-tab-pane>
      </el-tabs>
    </main>
  </div>
</template>

<script>
import {
  auditAppRelease,
  deleteAppRelease,
  findAllCheckingReleaseByAppId,
  findAllPassReleaseByAppId
} from "@/api/AppRelease";
import {Message} from "element-ui";
import {findAppAuthorityByAppId} from "@/api/AppAuthority";

export default {
  name: "ReleaseList",
  mounted() {
    this.loadData()
  },
  data() {
    return {
      appInfo: {
        appId: this.$route.query.appId,
        appName: this.$route.query.appName,
        isOwner: this.$route.query.isOwner,
        enableCheckRelease: false
      },
      loadingCheckingData: false,
      loadingPassData: false,
      checkDialogVisible: false,
      checkingReleaseList: [],
      passReleaseList: [],
      checkReleaseData: undefined,
      viewDialogVisible: false,
      viewReleaseData: undefined
    };
  },
  methods: {
    loadData() {
      this.loadCheckingReleaseList()
      this.loadPassReleaseList()
      this.appInfo.isOwner ? this.appInfo.enableCheckRelease = true : this.loadAppAuthority()
    },
    loadCheckingReleaseList() {
      this.loadingCheckingData = true
      findAllCheckingReleaseByAppId(this.appInfo.appId).then(res => {
        this.checkingReleaseList = res.data.content
        this.loadingCheckingData = false
      }).catch(() => {
        this.loadingCheckingData = false
      })
    },
    loadPassReleaseList() {
      this.loadingPassData = true
      findAllPassReleaseByAppId(this.appInfo.appId).then(res => {
        this.passReleaseList = res.data.content
        this.loadingPassData = false
      }).catch(() => {
        this.loadingPassData = false
      })
    },
    loadAppAuthority() {
      findAppAuthorityByAppId(this.appInfo.appId).then(res => {
        this.appInfo.enableCheckRelease = res.data.enableCheckRelease
      })
    },
    handleAuditRelease(releaseId) {
      auditAppRelease(releaseId).then(() => {
        Message({
          message: "审核发布通过成功",
          type: "success",
          duration: 3 * 1000
        })
      })
      setTimeout(this.loadCheckingReleaseList, 100)
      this.checkDialogVisible = false
    },
    handleDeleteRelease(releaseId) {
      deleteAppRelease(releaseId).then(() => {
        Message({
          message: "删除成功",
          type: "success",
          duration: 3 * 1000
        })
        setTimeout(this.loadCheckingReleaseList, 100)
      })
    },
    indexMethod(index) {
      return index + 1
    },
    openCheckDialog(row) {
      this.checkReleaseData = row
      this.checkDialogVisible = true
    },
    openViewDialog(row) {
      this.viewReleaseData = row
      this.viewDialogVisible = true
    },
    getCreatorName(creator) {
      return creator.realName == null ? creator.username : creator.realName;
    },
    getShortRule(ruleList) {
      if (ruleList.length == 0) {
        return "无";
      }
      let rule = ruleList[0];
      let res = "" + rule.dataName;
      if (rule.ruleFunctions.length == 0) {
        return res;
      }
      res = res + " " + rule.ruleFunctions[0].operator + " " + rule.ruleFunctions[0].compareTo;
      return res;
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 56px;
  background: #f4f9ff;
}

.header .path {
  color: rgba(102, 102, 102, 100);
  font-size: 14px;
}

.header .active {
  color: rgba(51, 51, 51, 100);
  font-size: 16px;
  font-weight: bold;
}

.main {
  margin: 12px 16px;
  background: #ffffff;
  border-radius: 4px;
  min-height: calc(100vh - 44px - 56px - 24px - 50px);
  padding: 22px 32px;
  position: relative;
}
</style>
